import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { getOneIn, getOneInByReferencia } from '../../../services/crudCustom';
import Swal from 'sweetalert2';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { ButtonSubmit } from '../../modules/ui/ButtonSubmit';
import moment from 'moment';
import { insertSolicitudFactura } from '../../../services/insertSolicitudFactura';
import { SelectCustom } from '../../modules/ui/SelectCustom';


const RegistroConfirmado = () => {
    // Hook que obtiene los parametros que se envian por la url
    const { referencia } = useParams();

    const [participantData, setParticipantData] = useState(null);

    // state para la forma de pago
    const [detalles, setDetalles] = useState({
        formaPago: "",
        importe: "",
    });
    const { importe, formaPago } = detalles;
    const handleDetallesChange = ({ target }) => {
        console.log(target.name, target.value);
        setDetalles({
            ...detalles,
            [target.name]: target.value,
        });
    };


    // Al presionar enviar
    const handleSubmit =async (event) => {
        event.preventDefault();
        console.log({participantData});

        const { 
            partNombres, partApellidoPaterno, partApellidoMaterno,
            educonResponsableId, infoAdicional, partCorreo, registroClaveProyecto, registroReferencia 
        } = participantData;
        const { 
            factNombre, factRFC, factCP, partTelefono, factRegimenFiscal, factUsoCFDI, compPagoURL, educonCorreo, educonTitulo, factExtranjero, requiereFactura
        } = infoAdicional;
        // Valores por default del contribuyente
        const contribuyente = {
            clienteID: 0,
            numeroCliente: 0,
            nombreCliente: factNombre || '',
            rfcCliente: factRFC || '',
            codigoPostal: factCP || '',
            correoElectronico: educonCorreo || '',
            regimenFiscalID: factRegimenFiscal || '',
            usoCFDI: factUsoCFDI || '',
        }

        // No requiere factura, obten el cliente desde la BDD
        if (!requiereFactura) {
            // TODO: obtener el contribuyente publico en general
            const { data } = await getOneIn({ table: 'CatalogoClientes', id:'3' });
            const contrib = data[0];
            console.log(contrib);

            contribuyente.clienteID = contrib.clienteID;
            contribuyente.numeroCliente = contrib.numeroCliente;
            contribuyente.nombreCliente = `${ partNombres } ${ partApellidoPaterno } ${ partApellidoMaterno }`
            contribuyente.rfcCliente = contrib.rfcCliente;
            contribuyente.codigoPostal = contrib.codigoPostal;
            contribuyente.correoElectronico = contrib.email;
            contribuyente.regimenFiscalID = '11';
            contribuyente.usoCFDI = 'S01';
            
        }
        // Es extranjero y si quiere factura
        if ( factExtranjero && requiereFactura ) {
            // TODO: obtener el contribuyente extranjero
            const { data } = await getOneIn({ table: 'CatalogoClientes', id:'2' });
            const contrib = data[0];

            contribuyente.clienteID = contrib.clienteID;
            contribuyente.numeroCliente = contrib.numeroCliente;
            contribuyente.nombreCliente = `${ partNombres } ${ partApellidoPaterno } ${ partApellidoMaterno }`
            contribuyente.rfcCliente = contrib.rfcCliente;
            contribuyente.codigoPostal = contrib.codigoPostal;
            contribuyente.correoElectronico = contrib.email;
            contribuyente.regimenFiscalID = '11';
            contribuyente.usoCFDI = 'S01';
        }

        //* Realizar el procedimiento de solicitar factura
        const values = {
            fecha: moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss'),
            nombreCliente: contribuyente.nombreCliente,
            // Estos valores son los que cambiamos si no quiere factura o 
            // si si quiere pero es extranjero
            clienteID: contribuyente.clienteID,
            numeroCliente: contribuyente.numeroCliente,
            rfcCliente: contribuyente.rfcCliente,
            codigoPostal: contribuyente.codigoPostal,
            correoElectronico: contribuyente.correoElectronico,
            regimenFiscalID: contribuyente.regimenFiscalID,
            usoCFDI: contribuyente.usoCFDI,

            telefonoCliente: partTelefono || '',
            correoEvento: partCorreo || '',
            proyecto: registroClaveProyecto,
            envioSolicitud: educonTitulo ? 'educon' : "eventos",
            solicitanteID: educonResponsableId || 494,
            ejercicio: moment().format("YYYY"),
            quienRegistro: educonResponsableId || 494,
            importe: importe !== '' ? importe : '0', 
            formaPago: formaPago !== '' ? formaPago : '03',
            NumeroRegistro: registroReferencia,
            archivoPDF: compPagoURL,
        };

        console.log({values});
 
        // //* Se guarda la solicitud de factura y su detalle
        // const insertResult = await insertSolicitudFactura(values);
        // console.log(insertResult);
    }


    // Establece los datos para generar la solicitud de factura
    useEffect(() => {
        const getParticipantData = async() => {
            const { exito, mensaje, data } = await getOneInByReferencia({ table:'RegistroGeneral', referencia });
    
            if (exito === 0) {
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: `Referencia invalida [ ${ referencia } ]`,
                    text: `Mensaje del servidor: "${ mensaje }"`,
                    showConfirmButton: false,
                    icon: 'error',
                });
                return;
            }
            const item = data[0];
            const infoAdicional = JSON.parse(item.infoAdicional);
    
            setParticipantData({ ...item, infoAdicional });
        }
        getParticipantData();
    }, [ referencia ]);
 
    useEffect(() => {
        console.log( participantData );
    }, [ participantData ]);

 
    // Para evitar flasheos
    if (!participantData) return <></>;
    
    return (
        <Box component="form" noValidate onSubmit={handleSubmit}>
            <Grid container maxWidth='md' padding={ 2 } spacing={ 1 }>
                <Grid item xs={ 12 }>
                    <h2>
                        Registro confirmado: { participantData.registroReferencia }
                    </h2>
                    <Typography>
                        Registro ID: { participantData.id } - { participantData.partApellidoPaterno } { participantData.partApellidoMaterno } { participantData.partNombres }
                    </Typography>
                </Grid>
                <Grid item xs={ 12 }>
                    <a href={ participantData.infoAdicional.compPagoURL } target='_blank'>Comprobante de pago</a>
                </Grid>


                <Grid item xs={8}>
                    <SelectCustom 
                    parentCallback={handleDetallesChange}
                    name={"formaPago"}
                    label={"Forma de pago"}
                    variant={"outlined"}
                    options={[
                        {value:'01', label:'Efectivo'},
                        {value:'02', label:'Cheque nominativo'},
                        {value:'03', label:'Transferencia'},
                        {value:'04', label:'Tarjeta de crédito'},
                        {value:'05', label:'Monedero electrónico'},
                    ]}
                    required
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField 
                        type={"number"}
                        fullWidth
                        inputProps={{ style: { textAlign: 'right' }}}
                        label="Importe *"
                        id="importe"
                        name="importe"
                        size="small"
                        value={importe}
                        onChange={handleDetallesChange}
                    />
                </Grid>
                

                {/* Boton submit */}
                <Grid item xs={12}>
                    <ButtonSubmit label='Solicitar factura' variant='contained' />
                </Grid>
            </Grid>
        </Box>
    )
}

export default RegistroConfirmado;